import "@/theme/initTheme";
import React from "react";
import ReactDOM from "react-dom/client";
import { LazyMotion } from "motion/react";
import "./index.css";
import "@/styles/theme.css";
import "leaflet/dist/leaflet.css";
import "./lib/leafletIcons"; // 👈 aquí
import Providers from "./app/providers";
import AppRouter from "./routes/AppRouter";

// La carga arranca ya, en paralelo con el render: los m.* que entran desde
// opacity 0 (carrusel, AuthShell) no esperan a que se pida el chunk.
const motionFeatures = import("./lib/motion-features").then((m) => m.default);
const loadMotionFeatures = () => motionFeatures;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* Un solo proveedor de motion: LazyMotion estricto + domAnimation (solo m.*),
        con las features en un chunk asíncrono para no sumarle ~29 kB gzip a la
        entrada (F1). Mismo criterio que KwMotionProvider de @minegocio/shared/ui,
        que la tienda todavía no declara como dependencia (PARA de F1). */}
    <LazyMotion features={loadMotionFeatures} strict>
      <Providers>
        <AppRouter />
      </Providers>
    </LazyMotion>
  </React.StrictMode>
);
